<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                礼物管理
               
            </div>     
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <!-- <div class="lft pointer" :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"  > 推荐 </div> -->
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid;out_guid = item.guid" :key="num"> <span v-if="num != 0">&nbsp; <span class="cBlack">/</span>  &nbsp;</span> {{item.name}} </div>
                                         
                            </div> 
                             
                            <Button class="rgt mR20 top14" @click="route='/layout/circle/gift/add';out_btnFun(null,0)"  type="info">添加礼物</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>   
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">礼物列表 </div> 
                                       
                            </div> 
                            
                            
                        </Row>        
                    </div>
                  
                    <Table     border :columns="columns1" :data="data1" ref='table' >
                 
                        <!-- 播放试听 -->
                        <template slot-scope="{ row, index }" slot="image" >
                            <div class="demo-avatar">
                                <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                                <Avatar v-else  :src="row.image" size="large"/> 
                            </div>  
                        </template>                      
                        <template slot-scope="{ row, index }" slot="btn" >
                 
                            <span  >
                                <Poptip trigger="hover"   content="编辑">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/gift/editor";out_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="删除">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/gift/del";out_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                                </Poptip>
                            </span>

                        </template>                      
                          
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                </div>
            </div>
        </div>

        <!-- 添加礼物,编辑礼物,删除礼物 -->
        <Modal
            v-model="out_btn"
            :title="out_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='out_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='out_btnSucc'>{{out_succ}}</Button>
            </div>
            
            <p  v-if="out_btn_num == 2">确定删除礼物吗?</p>
            <ul class="layout_ul" v-if="out_btn_num != 2">
               
                <!-- 礼物名称 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 礼物名称 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model1"   type='text' class="ipt"  placeholder="请输入礼物名称"    />
                    </div>                                            
                </li>
                <!-- 单选 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con padt2">
                        <RadioGroup v-model="out_model2">
                            <Radio v-for="(item,num) in data"  :label="item.guid" :key="num">      
                                <span>{{item.name}}</span>
                            </Radio>
                            
                        </RadioGroup>
                    </div>                                            
                </li>
                <!-- 持续时间 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 持续时间 :</div> 
                    <div class="list_con">
                        
                        <Row :gutter='12'>
                            <Col span="12" class='bottom5'>
                                <Input  v-model="time_d"   type='number' class="ipt"  placeholder="请输入天数"      >
                                    <span    slot="append" >天</span>
                                </Input>
                            </Col>
                            <Col span="12" class='bottom5'>
                                <Input   v-model="time_h"   type='number' class="ipt"  placeholder="请输入小时"    >
                                    <span    slot="append" >时</span>
                                </Input>   
                            </Col>
                            <Col span="12">
                                <Input   v-model="time_m"   type='number' class="ipt"  placeholder="请输入分钟"    >
                                    <span    slot="append" >分</span>
                                </Input>
                            </Col>
                            <Col span="12">
                                <Input   v-model="time_s"   type='number' class="ipt"  placeholder="请输入秒"    >
                                    <span    slot="append" >秒</span>
                                </Input>
                            </Col>
                        </Row>
                        
                        
                        
                        
                    </div>                                            
                </li>
                <!-- 孝心值 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 孝心值 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model6"   type='number' class="ipt"  placeholder="请输入孝心值"    />
                    </div>                                            
                </li>
                <!-- 排序 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model3"   type='number' class="ipt"  placeholder="请输入排序"    />
                    </div>                                            
                </li>
                
                <!-- 上传附件 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传图片 :</div> 
                    <div class="list_con">
                        <cropper @childFun="childFun2"      :data="cropper_data"  ></cropper>

                        
                    </div>                                            
                </li>
                
                <!-- 是否隐藏 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 显示状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model5" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_out_display" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
        <!-- 查看类目  -->
        <Modal
            v-model="lm"
            title="礼物类目"
            class-name="vertical-center-modal"
            width="1000"
            >
            <div slot="footer">     
                <Button type='primary' size='large' @click='lookSucc'>关闭</Button>
            </div>
            <div class="my_table bottom20"  >
                    
                <div class="my_search" style="margin-bottom:1px;">
                    
                    <Row class="search_row">  
                        <div  class="search_name">           <!--  0 添加; 1 编辑; 2 删除  -->
                        <Button class="mR5"    type="info"    @click='route="/layout/circle/gift/m_add";m_btnFun(null,0);' > <Icon type="md-add" />添加</Button>                              
                        </div>
                        
                    </Row>
                    
                </div>
                <Table     border :columns="columns" :data="data" ref='table' >
                    <template slot-scope="{ row, index }" slot="btn" >
                 
                        <span  >
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/gift/m_editor";m_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/gift/m_del";m_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        </span>

                    </template>                        
                </Table>
            
            </div>
        </Modal> 

        <!-- 类目弹窗的按钮弹窗 -->
        <Modal
            v-model="m_btn"
            :title="m_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='m_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='m_btnSucc'>{{m_succ}}</Button>
            </div>
            
            <p  v-if="m_btn_num == 2">确定删除类目吗?</p>
            <ul class="layout_ul" v-if="m_btn_num != 2">
               
                <!-- 分类名称 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类名称 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model1"   type='text' class="ipt"  placeholder="请输入分类名称"    />
                    </div>                                            
                </li>
                <!-- 分类描述 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model2"   type='text' class="ipt"  placeholder="请输入分类描述"    />
                    </div>                                            
                </li>
                <!-- 分类排序 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model3"   type='number' class="ipt"  placeholder="请输入分类排序"    />
                    </div>                                            
                </li>
                <!-- 分类状态 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="m_model4" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_btn" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    import cropper from '../../child_vue/vue_cropper.vue';
    import aplayer from 'vue-aplayer';
    export default {
        name:'recommend',
        data () {
            return {
                
                token: null,
                route: null,
                guid: null, 
                my_guid:null,
                titles: [],
                title_num: 0,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 20,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:null,  //场景guid
                out_model3:0,  //场景排序    
                out_model5:0,  //是否隐藏
                out_model6:0,     //收取孝心值
                time_d: null,   //放置天
                time_h: null,   //放置小时
                time_m: null,  //放置分钟
                time_s: null,  //放置秒
                

                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //分类描述
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传礼物
                up_data: null,
                file_name: null,
                file_path: null,

                

                // 上传图片
                            
                cropper_data:{
                    btn_name: '上传图片',
                    outputType: 'png',  //生成图片格式
                    type:'3',
                    vCropper:'5',
                    enlarge:"2.15", 
                    autoCropWidth:"200",
                    autoCropHeight:"200"
                },  

                child_val: null,  //child 反馈
            }
        },
     
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           }
          
        },
        components: {
          aplayer,cropper
        },
        computed: {
            
       
        },
        
        
        methods: {
            m_first_guid(){
                let that = this;
                that.$myAjax.get('admin/service/admin/goods/type').then( res => {
                  that.guid = res.data.data[0].guid;
                  that.load1();
                })
            },
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/goods/type').then( res => {
                  that.titles = res.data.data;
                  
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'name',align:'center',minWidth: 100,ellipsis: true},
                       {title:'分类描述',key:'content',align:'center',minWidth:150},
                       {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/goods/type?route=/layout/circle/gift/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                 that.load()
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'添加时间',key:'createTime',align:'center',minWidth:110,maxWidth:190},
                      {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  
                  that.out_model2 = that.data[0].guid;
                  this.$data_null.editor(that.data);
                
              })
          },
          load1(){
              
              let that = this;
              
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size,
               
              };
              
              
              that.$myAjax.get('admin/service/admin/type/goods'+that.$ajaxNull.get(data)).then( res => {
                  that.columns1 = [
                        {title:'排序',key:'sort',align:'center',width: 80},
                        {title:'名称',key:'name',align:'center',minWidth: 250},
                        {title:'头像',slot:'image',align:'center',minWidth:100},
                        {title:'摆放时间',key:'putTime2',align:'center',minWidth: 170,maxWidth: 220},
                        {title:'孝心值',key:'money',align:'center',minWidth: 80},
                        {title:'状态',key:'display',align:'center',minWidth:110,maxWidth: 180,
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display ,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/goods?route=/layout/circle/gift/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                 that.load1()
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                        },
                        {title:'创建时间',key:'createTime',align:'center',minWidth: 110,maxWidth:190},
                        {title:"操作",slot:"btn",align:"center",width:130,fixed: 'right'},
                  ]; 
                  
                  that.data1 = res.data.data.list;
                  let len = that.data1.length;
                  
                          
                  for(let i=0;i<len;i++){
                        let d,h,m,s,time = that.data1[i].putTime;
                        
                        d = Math.floor(time/(24*3600));
                        h = Math.floor(time%(24*3600)/3600);
                        m = Math.floor(time%3600/60);
                        s = Math.floor(time%60);
                        
                        // h<10 && (h='0'+h);
                        // m<10 && (m='0'+m);
                        // s<10 && (s='0'+s);

                        if(d){                          
                            that.data1[i].putTime2 = d+'天 '+h+'小时'+m+'分钟'+s+'秒';
                        }else if(h){
                            that.data1[i].putTime2 = h+'小时'+m+'分钟'+s+'秒';
                        }else if(m){
                            that.data1[i].putTime2 = m+'分钟'+s+'秒';
                        }else if(s){
                            that.data1[i].putTime2 = s+'秒';
                        }
                        
                  }

                  this.$data_null.editor(that.data1);
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;
                
              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          


            // 添加礼物
            //礼物 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            out_btnFun(row,num){
                let that = this;
                
                that.out_btn = true;
                that.out_btn_num = num;
                
                if(that.out_btn_num == 0){
                    that.out_title = "添加礼物";
                    that.out_succ = "添加";
                }else if(that.out_btn_num == 1){
                    that.out_guid = row.guid;
                    that.out_title = "编辑礼物";
                    that.out_succ = "修改";
                    
                }else if(that.out_btn_num == 2){
                    that.out_guid = row.guid;
                    that.out_title = "提示";
                    that.out_succ = "删除";
                }
                if(num == 0){
                    that.out_model1 = null;
                    // that.out_model2 = null;
                    that.out_model3 = null;   //排序
                    
                    that.out_model5 = 0;
                    that.out_model6 = null;    //收取孝心值

                    // 摆放时间
                    that.time_d = null;
                    that.time_m = null;
                    that.time_h = null;
                    that.time_s = null;
                    that.child_val = null;
                }else if(num == 1){
                    that.out_model1 = row.name;
                    that.out_model2 = row.goodsTypeGuid;
                    that.out_model3 = row.sort;
                    
                    that.out_model5 = row.display;
                    that.out_model6 = row.money;
                    
                    // 摆放时间
                    let time = row.putTime;
                    that.time_d = Math.floor(time/(24*3600));
                    that.time_h = Math.floor(time%(24*3600)/3600);
                    that.time_m = Math.floor(time%3600/60);
                    that.time_s = Math.floor(time%60);

                    that.child_val = null;
                }
            },
            out_btnFail(){
                this.out_btn = false;
            },
            out_btnSucc(){
                let that = this;
                
                let sort = that.out_model3?JSON.parse(that.out_model3):null;
                let money = that.out_model6?JSON.parse(that.out_model6):null;
                let putTime = that.time_d*(24*3600)+that.time_h*3600+that.time_m*60+that.time_s;
                if(!putTime && that.out_btn_num != 2){
                    that.$alert.info('请输入持续时间');
                    return false;
                }
                let data = {
                    name: that.out_model1,
                    goodsTypeGuid: that.out_model2,
                    sort: sort,
                    display: that.out_model5,
                    money: money,
                    image: null,
                    putTime: putTime         
                }
                this.$data_null.del(data);
                let bn = that.out_btn_num;
               
                
                if( bn != 2){
                    if(!that.child_val){
                        data.guid = null;
                        data.image = null; 
                        if(bn == 0){
                            that.$myAjax.post('admin/service/admin/goods?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }else if(bn == 1){
                            
                            data.guid = that.out_guid;
                            that.$myAjax.put('admin/service/admin/goods?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }
                    }else{
                        that.$upload(
                            that.child_val
                        ).then(res => { 
                            data.guid = null;
                            data.image = res.data.data.name;
                            if(bn == 0){
                                that.$myAjax.post('admin/service/admin/goods?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }else if(bn == 1){
                                
                                data.guid = that.out_guid;
                                that.$myAjax.put('admin/service/admin/goods?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }
                        }).catch(res => {

                        });
                    }

                }else if(that.out_btn_num == 2){
                    
                    that.$myAjax.delete('admin/service/admin/goods?route=' + that.route+'&guid='+that.out_guid).then( res => {
                        if(res.data.code == 1){
                            that.out_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
                

                
            },
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  type: "1"

                };
                this.$data_null.del(data);
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/background/search'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            
           
           change_out_display(bool){
               this.out_model5 = bool;
               
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
              
            },
            //   查看类目
            lookFun(){
                this.lm = true;
            },
            lookSucc(){
               this.lm = false;
            },
            //类目 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            m_btnFun(row,num){
                let that = this;
                
                that.m_btn = true;
                that.m_btn_num = num;
                
                if(that.m_btn_num == 0){
                    that.m_title = "添加类目";
                    that.m_succ = "添加";
                }else if(that.m_btn_num == 1){
                    that.m_guid = row.guid;
                    that.m_title = "编辑类目";
                    that.m_succ = "修改";
                    
                }else if(that.m_btn_num == 2){
                    that.m_guid = row.guid;
                    that.m_title = "提示";
                    that.m_succ = "删除";
                }
                if(num == 0){
                    that.m_model1 = null;
                    that.m_model2 = null;
                    that.m_model3 = null;
                    that.m_model4 = 0;
                }else if(num == 1){
                    that.m_model1 = row.name;
                    that.m_model2 = row.content;
                    that.m_model3 = row.sort;
                    that.m_model4 = row.display;
                }
            },
            m_btnFail(){
                this.m_btn = false;
            },
            m_btnSucc(){
                let that = this;
                let data = {
                    name: that.m_model1,
                    content: that.m_model2,
                    sort: that.m_model3,
                    display: that.m_model4,
                    
                    position: 1
                }
                if(that.m_btn_num == 0){
                   
                    that.$myAjax.post('admin/service/admin/goods/type?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                        
                    })
                }else if(that.m_btn_num == 1){
                    
                    let data1 = data;
                    data1.guid = that.m_guid;
                    that.$myAjax.put('admin/service/admin/goods/type?route=' + that.route,that.$ajaxNull.post(data1)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 2){
                    data.guid = that.m_guid;
                    that.$myAjax.delete('admin/service/admin/goods/type?route=' + that.route +'&guid='+ that.m_guid ).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
            },
            

           

            // 上传图片反馈
            childFun2 (data){
                let that = this;
                that.child_val = data.pic_url;          
                
            }

          
            
         
        },
        mounted: function(){
           let that = this;
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           that.m_first_guid();
           that.load();
        //    that.load1();

        }
    }
</script>
<style scoped>
    
</style>